export const ACTIONS = {
  TOGGLE_TALK_CALCULATOR: 'TOGGLE_TALK_CALCULATOR',
  NEW_REWARD_ELEMENT_RECEIVED: 'NEW_REWARD_ELEMENT_RECEIVED',
};

export const toggleTalkCalculator = isActive => ({
  type: ACTIONS.TOGGLE_TALK_CALCULATOR,
  payload: { isActive },
});

export const receiveNewRewardElement = name => ({
  type: ACTIONS.NEW_REWARD_ELEMENT_RECEIVED,
  payload: { name },
});
